import builderQuery, { QueryOptions } from 'odata-query';

export const buildQueryFilter = <T>(
  query: Partial<QueryOptions<T>> | undefined
): string | undefined => {
  if (!query) {
    return undefined;
  }

  const replaceFunc: (text: string) => string = (text: string) => {
    return text.replace(/'/g, '');
  };

  let filter = query?.filter
    ? builderQuery({ filter: query.filter })
    : undefined;

  if (filter) {
    filter = decodeURIComponent(filter);
    filter = filter.replace(
      /'[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}.[0-9]{3}Z'/gi,
      replaceFunc
    );
  }

  return filter?.replace('?$filter=', '');
};
